import React from 'react';
import { Controller, type Control, type UseFormRegister } from 'react-hook-form';
import { clsx } from 'clsx';
import type { GreenBeanProfileFormValues } from './useGreenBeanProfileForm';
import { useLanguage } from '../../features/language/useLanguage';

interface GreenBeanNotesSectionProps {
  control: Control<GreenBeanProfileFormValues>;
  register: UseFormRegister<GreenBeanProfileFormValues>;
}

export const GreenBeanNotesSection: React.FC<GreenBeanNotesSectionProps> = ({ control, register }) => {
  const { t } = useLanguage();
  return (
  <div className="space-y-4">
    <hr className="my-4 border-gray-300" />
    <Controller
      control={control}
      name="sample_physical_check"
      render={({ field }) => (
        <div className="space-y-2">
          <div className="flex items-center gap-4">
            <label className="w-40 shrink-0 block text-sm font-medium text-gray-700">
              {t('cupping.formSections.labels.physicalCheckPassed')}
            </label>

            <div className="flex gap-3">
              <button
                type="button"
                onClick={() => field.onChange(field.value === true ? null : true)}
                className={clsx(
                  'px-4 py-2 rounded-md text-sm font-medium border',
                  field.value === true
                    ? 'bg-green-600 text-white border-green-600'
                    : 'bg-white text-gray-700 border-gray-300'
                )}
                data-test-id="green-bean-physical-check-yes"
              >
                {t('cupping.formSections.labels.yes')}
              </button>

              <button
                type="button"
                onClick={() => field.onChange(field.value === false ? null : false)}
                className={clsx(
                  'px-4 py-2 rounded-md text-sm font-medium border',
                  field.value === false
                    ? 'bg-red-600 text-white border-red-600'
                    : 'bg-white text-gray-700 border-gray-300'
                )}
                data-test-id="green-bean-physical-check-no"
              >
                {t('cupping.formSections.labels.no')}
              </button>
            </div>
          </div>
        </div>
      )}
    />
    <hr className="my-4 border-gray-300" />

    <div className="mt-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">{t('reports.details.notes')}</label>
      <textarea
        {...register('origin_notes')}
        rows={4}
        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm border p-2"
        data-test-id="green-bean-origin-notes-input"
      />
    </div>
  </div>
  );
};
